import './bootstrap';

import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import type { DefineComponent } from 'vue';
import { createApp, h } from 'vue';
import { ZiggyVue } from 'ziggy-js';
import { initializeTheme } from './composables/useAppearance';
import Toast from 'vue-toastification'
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import { LoadingPlugin } from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';
import { configureEcho } from '@laravel/echo-vue';

configureEcho({
    broadcaster: 'pusher',
});
// import BootstrapPrimeVuePT from '@/primevue/passthrough/BootstrapPrimeVuePT';
import vue3GoogleLogin from 'vue3-google-login'
import 'vue-toastification/dist/index.css'
import '../css/app.scss'
//import './monaco-editor-environment.js';


// Extend ImportMeta interface for Vite...
declare module 'vite/client' {
    interface ImportMetaEnv {
        readonly VITE_APP_NAME: string;
        [key: string]: string | boolean | undefined;
    }

    interface ImportMeta {
        readonly env: ImportMetaEnv;
        readonly glob: <T>(pattern: string) => Record<string, () => Promise<T>>;
    }
}

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

// .use(PrimeVue, { unstyled: true, pt: BootstrapPrimeVuePT })
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./pages/${name}.vue`, import.meta.glob<DefineComponent>('./pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(Toast)
            .use(LoadingPlugin)
            .directive("tooltip", Tooltip)
            .use(ToastService)
            .use(vue3GoogleLogin, {
                clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID
            })
            .use(PrimeVue, {
                theme: {
                    preset: Aura,
                    options: {
                        darkModeSelector: false || 'none',
                    },
                    cssLayer: true
                }
            })
            .mount(el);
    },
    progress: {
        // The color of the progress bar...
        color: '#07edff',
        // The delay after which the progress bar will appear, in milliseconds...
        delay: 250,

        // Whether to include the default NProgress styles...
        includeCSS: true,

        // Whether the NProgress spinner will be shown...
        showSpinner: true,
    },
});


// This will set light / dark mode on page load...
initializeTheme();
